import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from '../../../../../styles/media.style';

const Answers = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;
  margin-bottom: 0;

  > div:last-child {
    margin-bottom: 42px;
  }

  ${media.tabletP`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;

    > div:last-child {
      margin-bottom: 15px;
    }
  `};

  &.column3 {
    > div {
      width: calc(100% / 3);
    }
  }
`;

const Answer = styled.div`
  width: 100%;
  padding: 0 6px;
  margin-bottom: 15px;

  ${media.tabletP`
    width: 50%;
  `};

  input {
    display: none;

    + label {
      display: flex;
      width: 100%;
      height: 68px;
      line-height: 1.4;
      vertical-align: middle;
      border: solid 1px #cccccc;
      padding: 0 10px 0 60px;
      position: relative;
      font-size: 12px;
      color: #000;
      align-items: center;

      ${media.tabletP`
        height: 72px;
        font-size: 16px;
      `};

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 20px;
        z-index: 1;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        border: 1px solid #989ea2;
        border-radius: 1000px;
      }
    }

    &:checked {
      + label {
        background-color: rgba(152, 158, 162, 0.15);
        border: 1px solid #9ba1a5;

        &:before {
          border: 1px solid #989ea2;
          background: #989ea2;
        }

        &:after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          left: 26px;
          z-index: 1;
          transform: translateY(-50%);
          width: 8px;
          height: 8px;
          background: #fff;
          border-radius: 1000px;
        }
      }
    }
  }
`;

const FreeTextWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 52px;
`;

const FreeText = styled.input`
  width: 100%;
  height: 20px;
  border: none;
  padding: 15px 0;
  margin-bottom: 10px;
  font-size: 16px;
  border-bottom: solid 1px #ddd;
  background-color: transparent;

  ${media.tabletP`
    padding: 15px 0;
    margin-bottom: 10px;
  `};
`;

class SingleChecker extends React.Component {
  state = {};
  render() {
    const { question, handleChecked, handleInput } = this.props;
    const { answers, freeDescriptionText } = question;
    return (
      <React.Fragment>
        <Answers>
          {answers.map(answer => (
            <Answer key={answer.slug}>
              <div>
                <input
                  type="radio"
                  id={`a${answer.slug}_${question.slug}`}
                  name={question.slug}
                  onChange={e => handleChecked(e, question, answer)}
                />
                <label htmlFor={`a${answer.slug}_${question.slug}`}>{answer.text}</label>
              </div>
            </Answer>
          ))}
        </Answers>
        {question.includeFreeDescription && (
          <FreeTextWrapper>
            <FreeText
              id={`${question.slug}-free-text`}
              name={question.slug}
              type="text"
              placeholder={freeDescriptionText}
              onInput={e => {
                handleInput(e, question);
              }}
            />
          </FreeTextWrapper>
        )}
      </React.Fragment>
    );
  }
}

SingleChecker.propTypes = {
  question: PropTypes.shape().isRequired,
  handleChecked: PropTypes.func.isRequired,
  handleInput: PropTypes.func.isRequired,
};

export default SingleChecker;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/Common/SingleChecker/SingleChecker.js